






















import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import { cloneDeep } from 'lodash';
@Component
export default class GroupForm extends BaseComponent {
  @Prop(Boolean)
  public isEdit!: boolean;

  @Prop()
  public editItem: any;

  public valid: boolean = false;

  public model: any = {
    nome: '',
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  @Watch('editItem')
  public onEditItemChange(val: any) {
    if (!val) {
      return;
    }
    this.model = cloneDeep(val);
  }

  public beforeMount(): void {
    this.onEditItemChange(this.editItem);
  }

  public onSaveClick(): void {
    const payload = cloneDeep(this.model); // Clones the Model into the Payload
    this.$emit('save', payload);
    this.$refs.form.resetValidation();
  }

  public onCloseClick(): void {
    const closeAction = () => {
      this.$emit('close');
      this.$refs.form.resetValidation();
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }
}
